<template>
  <div class="card-sections-block-footer">


    <div class="card-section" style="margin: 25px 0">
      <div class="card-section-header">
        <div class="card-section-header-name">Итого</div>
      </div>


      <el-table
        v-if="card.info"
        border
        size="mini"
        empty-text="Нет данных"
        :data="summary"
      >
        <el-table-column label="Плановая премия (итог)" v-slot="scope">
          <click-to-edit
            :number-format="{decimals: 2, space:true}"
            v-model="card.info.planned_bonus_result"
            :disabled="!elementToCheckBy.fields_permissions || !elementToCheckBy.fields_permissions['card.info.planned_bonus_result']"
            placeholder=""
            digits-only
            @input="saveInfoField('planned_bonus_result')"
          ></click-to-edit>
        </el-table-column>
        <el-table-column label="Вес (итог)" prop="weight" v-slot="scope">{{+scope.row.weight|numberFormat}}</el-table-column>
        <el-table-column label="Годовая зарплата" prop="year_salary" v-slot="scope">{{+scope.row.year_salary|numberFormat}}</el-table-column>
        <el-table-column label="% плановой премии от годовой зарплаты" prop="planned_bonus_to_year_salary" v-slot="scope">{{+scope.row.planned_bonus_to_year_salary|numberFormat}}</el-table-column>
        <el-table-column label="Отработанный период" prop="worked_period" v-slot="scope">
          {{ scope.row.worked_period }} %
        </el-table-column>
<!--        <el-table-column label="Общая сумма (опционы)" prop="options_sum" v-if="currentNegotiation && currentNegotiation.type !== 'self' "></el-table-column>-->
        <el-table-column label="Фактическая премия (итог)" prop="fact_bonus_result" v-if="card.status === $constants.card.statuses.STATUS_COMPLETED || (currentStage && currentStage.type === 'assessment')" v-slot="scope">{{+scope.row.fact_bonus_result|numberFormat}}</el-table-column>
        <el-table-column label="% фактической премии от годовой зарплаты" prop="fact_bonus_to_year_salary" v-if="card.status === $constants.card.statuses.STATUS_COMPLETED || (currentStage && currentStage.type === 'assessment')" v-slot="scope">{{+scope.row.fact_bonus_to_year_salary|numberFormat}}</el-table-column>
        <el-table-column label="Утвержденная премия (итог)" v-slot="scope" v-if="card.status === $constants.card.statuses.STATUS_COMPLETED || (currentStage && currentStage.type === 'assessment')">
          <click-to-edit
            v-model="card.info.agreed_bonus_result"
            :number-format="{}"
            :disabled="!elementToCheckBy.fields_permissions || !elementToCheckBy.fields_permissions['card.info.agreed_bonus_result']"
            placeholder=""
            digits-only
            @input="saveInfoField('agreed_bonus_result')"
          ></click-to-edit>
        </el-table-column>
      </el-table>

    </div>


    <div class="card-section" style="margin-bottom: 25px">
      <div class="card-section-header">
        <div class="card-section-header-name">Опционы</div>
      </div>

      <el-table
        border
        v-if="card.info"
        size="mini"
        show-summary
        :summary-method="getOptionsSummaries"
        empty-text="Нет опционов"
        :data="card.info.options"
      >
        <el-table-column min-width="400" label="Цикл ПДМ" v-slot="scope">
          <click-to-edit
            v-model="scope.row.cycle"
            :disabled="!elementToCheckBy.fields_permissions || !elementToCheckBy.fields_permissions['card.info.options']"
            placeholder=""
            style="width: 100%"
            @input="saveInfoField('options')"
          ></click-to-edit>
        </el-table-column>
        <el-table-column min-width="400" label="KPI" v-slot="scope">
          <click-to-edit
            v-model="scope.row.kpi"
            :disabled="!elementToCheckBy.fields_permissions || !elementToCheckBy.fields_permissions['card.info.options']"
            placeholder=""
            style="width: 100%"
            @input="saveInfoField('options')"
          ></click-to-edit>
        </el-table-column>
        <el-table-column width="250" label="Опцион (KPI)" v-slot="scope">
          <click-to-edit
            v-model="scope.row.option_kpi"
            :number-format="{}"
            :disabled="!elementToCheckBy.fields_permissions || !elementToCheckBy.fields_permissions['card.info.options']"
            placeholder=""
            style="width: 100%"
            @input="saveInfoField('options')"
          ></click-to-edit>
        </el-table-column>
        <el-table-column width="250" label="Опцион (удержание)" v-slot="scope">
          <click-to-edit
            v-model="scope.row.option_hold"
            :number-format="{}"
            :disabled="!elementToCheckBy.fields_permissions || !elementToCheckBy.fields_permissions['card.info.options']"
            placeholder=""
            style="width: 100%"
            @input="saveInfoField('options')"
          ></click-to-edit>
        </el-table-column>
        <el-table-column width="250" label="Сумма" v-slot="scope">
          {{scope.row.sum | numberFormat}}
        </el-table-column>
      </el-table>
    </div>







<!--    <table>-->
<!--      <tbody>-->
<!--      <tr>-->
<!--        <td>Плановая премия (итог)</td>-->
<!--        <td>-->
<!--          <click-to-edit-->
<!--            v-if="card.info"-->
<!--            v-model="card.info.planned_bonus_result"-->
<!--            placeholder=""-->
<!--            digits-only-->
<!--            @input="saveInfoField('planned_bonus_result')"-->
<!--          ></click-to-edit>-->
<!--        </td>-->
<!--      </tr>-->
<!--      <tr>-->
<!--        <td>Вес (итог)</td>-->
<!--        <td>{{summary[0].weight}}%</td>-->
<!--      </tr>-->
<!--      <tr>-->
<!--        <td>Годовая зарплата</td>-->
<!--        <td>{{card.info ? card.info.year_salary : 0}}</td>-->
<!--      </tr>-->
<!--      <tr>-->
<!--        <td>% плановой премии от годовой зарплаты</td>-->
<!--        <td>{{card.info ? card.info.planned_bonus_to_year_salary : 0}}</td>-->
<!--      </tr>-->
<!--      <tr>-->
<!--        <td>Отработанный период</td>-->
<!--        <td>{{card.info ? card.info.worked_period : 0}}%</td>-->
<!--      </tr>-->
<!--      <tr>-->
<!--        <td>Общая сумма (опционы)</td>-->
<!--        <td>{{card.info ? card.info.options_sum : ''}}</td>-->
<!--      </tr>-->
<!--      </tbody>-->
<!--    </table>-->


  </div>
</template>

<script>

import {mapGetters} from "vuex";
import {downloader} from "@/mixins/downloader";
import CloneElementsFromCardModal from "@/components/cards/CloneElementsFromCardModal.vue";
import HistoryModal from "@/components/HistoryModal.vue";
import StartDynamicStageButton from "@/components/cards/StartDynamicStageButton.vue";
import ClickToEdit from "@/components/ClickToEdit.vue";
import { cardInfoField } from "@/mixins/cardInfoField";
import {format} from "@/directives/NumberFormat";

export default {
  name: "card-sections-block-footer",
  mixins: [downloader, cardInfoField],
  components: { ClickToEdit, StartDynamicStageButton, HistoryModal, CloneElementsFromCardModal},
  props: {},

  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card: 'card'
    }),
    ...mapGetters('card/stages', {
      currentStage: 'currentStage',
      currentNegotiation: 'currentNegotiation',
    }),
    ...mapGetters('card/sections', {
      sections: 'sections',
      sectionsElements: 'sectionsElements',
    }),
    ...mapGetters('card/cascadingSection', {
      loading: 'loading',
      cascadingNodes: 'nodes',
    }),
    summary() {
      let totalWeight = 0;

      this.sections.forEach(section => {
        if( this.$companyConfiguration.cardSections.isSectionMultiplyElementsBonus(section.type) ){
          // Для кэфов не нужно считать вес
          return;
        }
        if( !this.sectionsElements[section.id] ){
          return;
        }
        this.sectionsElements[section.id].forEach(e => {
          totalWeight += +e.weight;
        })
      })

      if( this.$companyConfiguration.cascading.isEnabled() ){
        this.cascadingNodes.forEach(node => {
          totalWeight += (+node.model.card_weight || 0);
        })
      }

      return [{
        weight: +totalWeight.toFixed(2),
        planned_bonus_result: this.card.info?.planned_bonus_result,
        year_salary: this.card.info?.year_salary,
        planned_bonus_to_year_salary: this.card.info?.planned_bonus_to_year_salary,
        worked_period: this.card.info?.worked_period,
        options_sum: this.card.info?.options_sum,
        fact_bonus_result: this.card.info?.fact_bonus_result,
        fact_bonus_to_year_salary: this.card.info?.fact_bonus_to_year_salary,
        agreed_bonus_result: this.card.info?.agreed_bonus_result,
      }]
    },

    width() {
      let weightWidth = 0;
      let factWidth = 0;
      if (this.currentStage && this.currentStage.type === this.$constants.stage.types.TYPE_PLAN) {
        weightWidth = 810;
      }
      if (this.currentStage && this.currentStage.type === this.$constants.stage.types.TYPE_ASSESSMENT) {
        weightWidth = 1120;
        factWidth = 150;
      }
      if (this.card.status === this.$constants.card.statuses.STATUS_COMPLETED ) {
        weightWidth = 1120;
        factWidth = 150;
      }
      return {
        'weight': weightWidth,
        'fact': factWidth,
      }
    },
    elementToCheckBy() {
      if( !this.sections || !this.sections.length ){
        return {}
      }
      const elements = this.sectionsElements[this.sections[0].id];
      if( !elements || !elements.length ){
        return [];
      }
      return elements[0];
    }
  },
  watch: {},
  data() {
    return {
      savingInfoField: false,
    }
  },
  methods: {
    isFieldAvailableForEdit(element, fieldName) {
      return element.fields_permissions && element.fields_permissions[fieldName];
    },
    saveInfoField(fieldName) {
      this.savingInfoField = true;
      this.infoFieldChanged(fieldName)
        .then(() => {
          this.$store.dispatch('card/loadCardData');
          this.$store.dispatch('card/sections/loadSections');
          this.$store.dispatch('card/stages/loadStages');
        })
        .finally(() => {
          this.savingInfoField = false;
        })
    },
    getOptionsSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Итого';
          return;
        }
        if (index === 4) {
          if( !this.summary[0].options_sum ){
            sums[index] = 0;
            return;
          }
          sums[index] = this.summary[0].options_sum.toLocaleString('ru-RU', {
            maximumFractionDigits: 20,
          });
          return;
        }
      });

      return sums;
    }
  }
}
</script>


<style lang="scss">
.evraz-summary-row{
  font-weight: bold;
}
</style>